module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAA5klEQVQYGXXBPyuEARwA4N/rz11iQSjpyHDJYFCYnA8gBquND+DKYjNYDFYf4yKld7FapIw68yXXm0EySNfj6ty5Lp4n/iJRsRT/c4zF6CbvQNWbC8tyajJJ/DImQ+ZeAycmNWxHm8Sjurlo0u8IJWX1aDOLxehw7dYMRqPFGvLRYd+nEcxHi1ksRIcrt8YxHS0SVS8K0aTPITZsIhct+k15ReZOA6cGPatEmwdnhpU9eXdpxYAKJqLNLm7M6YswaFUVpehmy5dfNYXoZciOc3U1RUn0UnQtlcp8SKVS69FNSa+9+PENDuzd7J4y8bMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon.png
// module id = fqxG
// module chunks = 0